import { render, staticRenderFns } from "./UseSoil.vue?vue&type=template&id=71ecf032&scoped=true"
import script from "./UseSoil.vue?vue&type=script&lang=js"
export * from "./UseSoil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ecf032",
  null
  
)

export default component.exports